var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C0.44772 0 0 0.44772 0 1V17C0 17.5523 0.44772 18 1 18H19C19.5523 18 20 17.5523 20 17V1C20 0.44772 19.5523 0 19 0H1ZM9 2V5H2V2H9ZM2 11V7H9V11H2ZM2 13H9V16H2V13ZM11 13H18V16H11V13ZM18 11H11V7H18V11ZM18 2V5H11V2H18Z",
    fill: "#39B54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.d4a434475ab7320c09b7e584aa4d75ac.svg";
export { ForwardRef as ReactComponent };